export enum FormContext {
  UNKNOWN = "unknown",
  DETAIL_MAIN = "detail.main",
  POPOUT_MENU = "popout.menu",
  MODAL_FORM = "modal.form",
}
